import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedModule } from 'shared-ui/shared.module';
import { TopupAttention } from 'app/core/domains/billing-managment/history/topup-attention.model';
@Component({selector: 'topup-alert-popup', standalone: true, imports: [SharedModule],
    changeDetection: ChangeDetectionStrategy.OnPush, templateUrl: './topup-alert-popup.component.html'})
export class TopupAlertPopupComponent {
    @Input() Visible = false; @Input() Model = new TopupAttention();
    @Output() visibleChange = new EventEmitter<boolean>(); @Output() review = new EventEmitter<void>();
    private openQueue = false;
    hide(openQueue = false): void { this.openQueue = openQueue; this.visibleChange.emit(false); }
    hidden(): void { this.visibleChange.emit(false); if (this.openQueue) { this.openQueue = false; this.review.emit(); } }
}
